import React from "react";
import { Col, Row } from "react-bootstrap";
import { motion } from "framer-motion";

function ChatComponent() {
  return (
    <div className="cta-section-new">
      <div className="container">
        <motion.div
          className="cta-inner"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Row className="align-items-center">
            <Col xs={12} md={8}>
              <h3 className="cta-title-new">
                Ready to build something{" "}
                <span style={{ color: "#0a1a12" }}>intelligent</span>?
              </h3>
              <p className="cta-desc-new">
                Whether you need an LMS, HMS, distribution system, or something
                entirely custom — let's talk. Our team is ready to bring your
                vision to life with AI-powered precision.
              </p>
            </Col>
            <Col
              xs={12}
              md={4}
              className="d-flex justify-content-md-end justify-content-start"
            >
              <div className="cta-buttons-new">
                <a
                  className="btn btn-cta-dark"
                  href="mailto:contact@gowave.in"
                >
                  Contact Us
                </a>
                <a
                  className="btn btn-cta-outline"
                  href="https://m.me/gowave009"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Chat on Messenger
                </a>
              </div>
            </Col>
          </Row>
        </motion.div>
      </div>
    </div>
  );
}

export default ChatComponent;
